import app from 'flarum/forum/app';
import on from './gate';
import Component from 'flarum/common/Component';
import LearnSongBox from './LearnSongBox';
export default class AskLearnCard extends Component {
  song = null;
  question = '';
  sequence = 0;
  oninit(v) {
    super.oninit(v);
    this.load();
  }
  onbeforeupdate() {
    if (this.question !== this.attrs.answer.question) this.load();
  }
  load() {
    if (!on()) return;
    const answer = this.attrs.answer;
    this.question = answer.question;
    const seq = ++this.sequence;
    if ('learnSong' in answer) {
      this.song = answer.learnSong;
      return;
    }
    this.song = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/match',
      params: {
        q: this.question
      },
      errorHandler: () => {}
    }).then(r => {
      if (seq === this.sequence) this.song = r.data;
    }).catch(() => {}).finally(() => m.redraw());
  }
  view() {
    if (!on()) return null;
    return this.song ? m(LearnSongBox, {
      song: this.song,
      ask: true
    }) : null;
  }
}